module.exports = __webpack_public_path__ + "static/media/back.d73588f0.png";